// Shared rooms use the configured Cocos host; links carry only a room and referral context.
export const TARNEEB_GAME_ID = "242";
const TARNEEB_AGENT_RID = /^[1-9][0-9]{0,19}$/;

export function readTarneebRoomInvite(search) {
  const query = new URLSearchParams(search);
  const rooms = query.getAll("tarneeb_room_id");
  const subids = query.getAll("tarneeb_subid");
  if (rooms.length !== 1 || subids.length !== 1) return null;
  const roomId = rooms[0];
  const subid = subids[0];
  if (!/^[A-Za-z0-9_-]{1,100}$/.test(roomId) || !/^[1-9][0-9]*$/.test(subid) ||
    !Number.isSafeInteger(Number(subid))) return null;
  return { roomId, subid };
}

export function isTarneebRegisteredPlayer(userInfo) {
  return Boolean(userInfo && userInfo.token && !userInfo.is_guest && !userInfo.is_demo);
}

export function tarneebInviteHomePath(search) {
  const invite = readTarneebRoomInvite(search);
  if (!invite) return null;
  const incoming = new URLSearchParams(search);
  const query = new URLSearchParams({ tarneeb_room_id: invite.roomId, tarneeb_subid: invite.subid });
  const agentRids = incoming.getAll("aid");
  if (agentRids.length === 1 && TARNEEB_AGENT_RID.test(agentRids[0])) query.set("aid", agentRids[0]);
  ["f", "c", "p"].forEach((key) => {
    const value = incoming.get(key);
    if (value && value !== "undefined" && value.length <= 128) query.set(key, value);
  });
  return `/home?${query.toString()}`;
}

export function tarneebGameUrlWithHall(gameUrl, gameId, hallOrigin) {
  if (String(gameId) !== TARNEEB_GAME_ID) return gameUrl;
  const url = new URL(gameUrl, hallOrigin);
  url.searchParams.set("game_id", TARNEEB_GAME_ID);
  url.searchParams.set("tarneeb_hall_url", new URL("/home", hallOrigin).href);
  return url.href;
}

export function tarneebGameUrlWithRoom(gameUrl, gameId, hallOrigin, outerSearch) {
  if (String(gameId) !== TARNEEB_GAME_ID) return gameUrl;
  const url = new URL(tarneebGameUrlWithHall(gameUrl, gameId, hallOrigin));
  const query = new URLSearchParams(outerSearch);
  if (query.has("tarneeb_room_id") || query.has("tarneeb_subid")) {
    url.searchParams.delete("tarneeb_room_id");
    url.searchParams.delete("tarneeb_subid");
    const invite = readTarneebRoomInvite(query);
    if (invite) {
      url.searchParams.set("tarneeb_room_id", invite.roomId);
      url.searchParams.set("tarneeb_subid", invite.subid);
    }
  }
  return url.href;
}

export function tarneebRoomGamePath(search, gameBaseUrl, hallOrigin) {
  const invite = readTarneebRoomInvite(search);
  if (!invite) return null;
  const url = new URL(tarneebGameUrlWithHall(gameBaseUrl, TARNEEB_GAME_ID, hallOrigin));
  url.searchParams.set("tarneeb_room_id", invite.roomId);
  url.searchParams.set("tarneeb_subid", invite.subid);
  const query = new URLSearchParams({ game_id: TARNEEB_GAME_ID, url: url.href,
    tarneeb_room_id: invite.roomId, tarneeb_subid: invite.subid });
  const homeQuery = new URLSearchParams(tarneebInviteHomePath(search).split("?")[1]);
  ["aid", "f", "c", "p"].forEach((key) => {
    const value = homeQuery.get(key);
    if (value) query.set(key, value);
  });
  return `/game?${query.toString()}`;
}

export function tarneebRegistrationPath(homePath) {
  const query = new URLSearchParams({ reg: "1", back_to: homePath });
  const channel = new URLSearchParams(homePath.split("?")[1]).get("c");
  if (channel) query.set("c", channel);
  return `/login?${query.toString()}`;
}

export function tarneebAuthReturnPath(backTo) {
  if (typeof backTo !== "string" || !backTo.startsWith("/home?")) return null;
  return tarneebInviteHomePath(backTo.slice("/home".length));
}

// Registration must use this invite's commission parent, never stale local attribution.
export function tarneebRegistrationAgentRid(backTo, storedAgentRid) {
  const homePath = tarneebAuthReturnPath(backTo);
  if (!homePath) return storedAgentRid || "";
  return new URLSearchParams(homePath.split("?")[1]).get("aid") || "";
}
